export enum EStatusCheck {
  success = 0,
  failed = 1,
}